import { Component, Input, Inject, AfterViewInit, ChangeDetectorRef, OnInit} from '@angular/core';
import { BackendApiService } from "../../../app/services/backend-api.service";
import * as $ from 'jquery';
import * as CanvasJS from "../../client/device-detail-nxt/canvasjs.stock.min";
import { BaseUrlConstantsService } from '../../../app/services/base-url-constants.service';
import {MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { ParametersListComponent } from '../parameters-list/parameters-list.component';
import { CommonModule } from '@angular/common';
@Component({
  selector: 'app-parameters-chart',
  templateUrl: './parameters-chart.component.html',
  styleUrls: ['./parameters-chart.component.scss'],
  standalone: true,
  imports: [CommonModule]
})
export class ParametersChartComponent implements OnInit, AfterViewInit {
  public chartData : any;
  public  chartOptions : any;
  public chartBgColors : any;
  public movingAvgData: any;
  public chartContainerId: any;
  // @Input() chartData: any; 
  // @Input() chartOptions: any;
  // @Input() chartBgColors:any
  // @Input() chartContainerId: any;
  // @Input() movingAvgData: any
  public valueType: string;
  public time_span: string;
  public accColor1: any = "active";
  public accColor2: any;
  public accColor3: any;
  public boilerParameter = BaseUrlConstantsService.BOILER_PARAMETERS_API;
  public clientId: string;
  public subsystemId: string;
  axisYData: any;
  public chartType: any;
  public errorMessage: string;
  axisXData: { gridThickness: number; tickLength: number; lineThickness: number; };
  minimum: number;
  maximum: any;
  navigatorEnabled: boolean;
  labelFormatter: (e: any) => string;
  public day_1: any;
  public days_7: any;
  public days_30: any;
  public chartUnit: any;
  public stripLines: any =[];
  //({ startValue: any; endValue: any; color: string; value?: undefined; label?: undefined; labelFontColor?: undefined; labelAlign?: undefined; } | { value: any; label: any; labelFontColor: string; labelAlign: string; startValue?: undefined; endValue?: undefined; color?: undefined; })[];
  constructor(private cdr: ChangeDetectorRef,
    private service: BackendApiService,
    public dialogRef: MatDialogRef<ParametersListComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any
  ) {
    this.chartData = this.data.chartData;
    this.chartOptions = this.data.chartOptions;
    this.chartContainerId = this.data.chartContainerId;
    this.chartBgColors = this.data.chartBgColors;
    this.movingAvgData = this.data.movingAvgData;
    if(localStorage.getItem('role') === 'ADMIN'){
      this.clientId = localStorage.getItem('admin_client_id');
    }else{
      this.clientId = localStorage.getItem('user_id');
    }
    this.subsystemId = localStorage.getItem('subsystem_id');
  }
  ngOnInit(){
    if(localStorage.getItem('role') === 'ADMIN'){
      this.clientId = localStorage.getItem('admin_client_id');
    }else{
      this.clientId = localStorage.getItem('user_id');
    }
    this.subsystemId = localStorage.getItem('subsystem_id');
    this.chartType = JSON.parse(JSON.stringify(this.chartData))[0].type;

  }
  ngAfterViewInit() {

    if (this.chartData && this.chartOptions && this.chartContainerId) {
      let chartContainerId = this.chartContainerId;
      let chartDataOriginal = JSON.parse(JSON.stringify(this.chartData));
      this.chartUnit = this.chartData[0].unit;
      let chartRangeDataOriginal = JSON.parse(JSON.stringify(this.chartBgColors));
    
      if (this.movingAvgData != undefined && this.movingAvgData.length !=0) {
        this.day_1 = this.movingAvgData.day_1.toFixed(2);
        this.days_7 = this.movingAvgData.days_7.toFixed(2);
        this.days_30 = this.movingAvgData.days_30.toFixed(2);
      } else {
        this.day_1 = 0;
        this.days_7 = 0;
        this.days_30 = 0;
      }
    
      if (chartDataOriginal[0].dataPoints.length !== 0 && chartDataOriginal[0].type === 'line') {
        this.errorMessage = "";
        this.axisXData = {
          gridThickness: 0,
          tickLength: 0,
          lineThickness: 0,
        };
        this.minimum = 0;  // Minimum value for the y-axis
        this.maximum = chartRangeDataOriginal.max_value;
        this.navigatorEnabled = true;
      } else if (chartDataOriginal[0].type !== 'line' && chartDataOriginal[0].dataPoints.length !== 0) {
        this.minimum = 0;  // Minimum value for the y-axis
        this.maximum = 1;
        this.navigatorEnabled = true;
        this.labelFormatter = function (e) {
          return "";
        };
      } else if ((chartDataOriginal[0].type === 'line' || chartDataOriginal[0].type === 'column') && chartDataOriginal[0].dataPoints.length === 0) {
        this.axisXData = {
          gridThickness: 0,
          tickLength: 0,
          lineThickness: 0,
        };
        this.minimum = 0;  // Minimum value for the y-axis
        this.maximum = 0;
        this.navigatorEnabled = false;
        this.errorMessage = "No data available.";
      }
    
      // Adjust strip lines for "econo" charts
      this.stripLines = [];
      if (this.chartOptions.toLowerCase().startsWith("econo")) {
        this.stripLines = [
          {
            startValue: 0,
            endValue: chartRangeDataOriginal.red,
            color: "rgba(255, 230, 230, 0.5)", // Red at the bottom
          },
          {
            value: chartRangeDataOriginal.red,
            label: chartRangeDataOriginal.red.toString(),
            labelFontColor: "#000000",
            labelAlign: "right",
          },
          {
            startValue: chartRangeDataOriginal.green,
            endValue: chartRangeDataOriginal.yellow,
            color: "rgba(255, 250, 196, 1)", // Yellow in the middle
          },
          {
            value: chartRangeDataOriginal.yellow,
            label: chartRangeDataOriginal.yellow.toString(),
            labelFontColor: "#000000",
            labelAlign: "right",
          },
          {
            startValue: chartRangeDataOriginal.yellow,
            endValue: chartRangeDataOriginal.red,
            color: "rgba(212, 237, 218, 1)", // Green at the top
          },
          {
            value: chartRangeDataOriginal.green,
            label: chartRangeDataOriginal.green.toString(),
            labelFontColor: "#000000",
            labelAlign: "right",
          },
        ];
      } else {
       this.stripLines = [
          {
            startValue: 0,
            endValue: chartRangeDataOriginal.green,
            color: "rgba(212, 237, 218, 1)", // Default: Green at the bottom
          },
          {
            value: chartRangeDataOriginal.green,
            label: chartRangeDataOriginal.green.toString(),
            labelFontColor: "#000000",
            labelAlign: "right",
          },
          {
            startValue: chartRangeDataOriginal.green,
            endValue: chartRangeDataOriginal.yellow,
            color: "rgba(255, 250, 196, 1)", // Yellow in the middle
          },
          {
            value: chartRangeDataOriginal.yellow,
            label: chartRangeDataOriginal.yellow.toString(),
            labelFontColor: "#000000",
            labelAlign: "right",
          },
          {
            startValue: chartRangeDataOriginal.yellow,
            endValue: chartRangeDataOriginal.red,
            color: "rgba(255, 230, 230, 0.5)", // Red at the top
          },
          {
            value: chartRangeDataOriginal.red,
            label: chartRangeDataOriginal.red.toString(),
            labelFontColor: "#000000",
            labelAlign: "right",
          },
        ];
      }
    
      let chart2 = new CanvasJS.StockChart(this.chartContainerId, {
        theme: "light2",
        animationEnabled: true,
        exportEnabled: false,
        zoomEnabled: true,
        legend: {
          enabled: true,
          verticalAlign: "top",
          horizontalAlign: "right",
          fontSize: 19,
          fontColor: "#191919",
          fontWeight: "normal",
          markerMargin: 10,
          fontFamily: "Roboto-Regular",
          cursor: "pointer",
        },
        title: {
          text: this.chartOptions,
          fontFamily: "Roboto-Regular",
          fontColor: "#444",
          fontSize: 30,
          margin: 50,
        },
        rangeSelector: {
          enabled: false,
        },
        navigator: {
          enabled: this.navigatorEnabled,
        },
        charts: [
          {
            axisX: this.axisXData,
            data: chartDataOriginal,
            axisY: {
              minimum: this.minimum,
              maximum: this.maximum,
              labelFormatter: this.labelFormatter,
              enabled: this.navigatorEnabled,
              stripLines: this.stripLines,
            },
            subtitles: [
              {
                text: chartDataOriginal[0].dataPoints.length === 0 ? "No data available." : "",
                verticalAlign: "center",
                horizontalAlign: "center",
                fontWeight: "bold",
              },
            ],
          },
        ],
      });
    
      chart2.render();
    }
    
  }
  closeFunction(){
    this.dialogRef.close();
  }
  selectFilterAccelartion(value,type) {
    switch (value) {
      case "Hourly":
        //this.valueTypeTrend = "hour";
        this.valueType = "hour";
        this.time_span = "hour";
        this.getChartData(this.valueType, type);
        this.accColor1 = "active";
        this.accColor2 = "";
        this.accColor3 = "";
        break;
      case "Daily":
        //this.valueTypeTrend = "day";
        this.valueType = "day";
        this.time_span = "day";
        this.getChartData(this.valueType, type);
        this.accColor1 = "";
        this.accColor2 = "active";
        this.accColor3 = "";
        break;
      case "Weekly":
        //this.valueTypeTrend = "week";
        this.valueType = "week";
        this.time_span = "week";
        this.getChartData(this.valueType, type);
        this.accColor2 = "";
        this.accColor1 = "";
        this.accColor3 = "active";
        break;
    }
  }
  getChartData(time_span,type){
    this.service.getData(this.boilerParameter + 'parameters/' +type + '/' + this.clientId + "/" + this.subsystemId +"/" + time_span).then(res => {
      let response = JSON.parse(JSON.stringify(res)).data;
      if (response.body.sensor.length != 0) {
        let chartDataOriginal = response.body.sensor;
        let chartRangeDataOriginal = response.body.rangeLabels;
        if(chartDataOriginal[0].dataPoints.length!== 0 && chartDataOriginal[0].type ==='line'){
          this.errorMessage = "";
          this.axisXData = {
            gridThickness: 0,
            tickLength: 0,
            lineThickness: 0,
          }
          
            this.minimum= 0,  // Minimum value for the y-axis
            this.maximum= chartRangeDataOriginal.max_value;
            this.navigatorEnabled = true;
        }else if(chartDataOriginal[0].type !=='line' && chartDataOriginal[0].dataPoints.length !== 0){
            this.minimum =0;  // Minimum value for the y-axis
            this.maximum= 1;
            this.navigatorEnabled= true;
            this.labelFormatter= function(e){
              return  "";
            }
        }else if((chartDataOriginal[0].type ==='line' || chartDataOriginal[0].type ==='column') && chartDataOriginal[0].dataPoints.length === 0){
          this.axisXData = {
            gridThickness: 0,
            tickLength: 0,
            lineThickness: 0,
          }
            this.minimum =0,  // Minimum value for the y-axis
            this.maximum =0,
            this.navigatorEnabled= false;
          this.errorMessage ="No data available.";
        }
        let chart2 = new CanvasJS.StockChart(this.chartContainerId, {
          theme: "light2",
          animationEnabled: true,
          exportEnabled: false,
          zoomEnabled: true,
          legend: {
              enabled: true,
              verticalAlign: "top",
              horizontalAlign: "right",
              fontSize: 19,
              fontColor: "#191919",
              fontWeight: "normal",
              markerMargin: 10,
              fontFamily: "Roboto-Regular",
              cursor: "pointer"
          },
          title: {
              text: this.chartOptions,
              fontFamily: "Roboto-Regular",
              fontColor: "#444",
              fontSize: 30,
              margin: 50
          },
         
          rangeSelector: {
           enabled: false
          },
          navigator: {
              enabled: this.navigatorEnabled
          },
          charts: [{
              axisX: this.axisXData,
              data: chartDataOriginal,
              
              axisY: {
                minimum:this.minimum,
                maximum: this.maximum,
                labelFormatter:this.labelFormatter,
                enabled:this.navigatorEnabled,
                stripLines: this.stripLines
              },
              subtitles: [
                {
                    text: chartDataOriginal[0].dataPoints.length == 0 ? "No data available." : "",
                    verticalAlign: "center",
                    horizontalAlign: 'center',
                    fontWeight: "bold"
                }
            ],
          }]

      });
      chart2.render();
      }
    })
  }
  updateChartData(newData: any) {
    this.chartData = newData.chartData;
    this.chartOptions = newData.chartOptions;
    this.chartBgColors = newData.chartBgColors;
    this.cdr.detectChanges(); // Trigger change detection
  }

}
